
import { Options } from "vue-class-component";
import FormMixin from "../../helpers/mixins/form";
import { SystemApi } from "../../autogen";
import { Field, Form } from "vee-validate";
import FieldLabel from "../atoms/FieldLabel.vue";
import * as yup from "yup";
import FieldError from "../atoms/FieldError.vue";
import Multiselect from "@vueform/multiselect";
import FormError from "../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
type FormValues = {
  clientName: string;
  departmentNames: [];
  maxEmployees: string;
};
@Options({
  components: { Field, Form, FieldLabel, FieldError, ActionButton, FormError, Multiselect }
})
export default class TrialAccountForm extends FormMixin {
  formName = "トライアル発行";
  defaultMaxEmployees = 3;
  departmentNames = [];
  departmentOptions = {
    ...this.multiSelectBaseOptions,
    max: 3,
    options: [],
    createOption: true
  };
  formValues: FormValues = {
    clientName: "",
    departmentNames: [],
    maxEmployees: ""
  };
  validationSchema!: yup.AnyObjectSchema;
  beforeCreate() {
    this.validationSchema = yup.object({
      clientName: yup
        .string()
        .trim()
        .required(this.$t("input_required", { field: "クライアント名" })),
      maxEmployees: yup.string().required(this.$t("input_required", { field: "上限従業員数" }))
    });
  }
  async onBeforeSubmit(formValues: FormValues) {
    await this.onSubmit(async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const submitValues = {
        clientName: formValues.clientName,
        departmentNames: this.departmentNames,
        maxEmployees: formValues.maxEmployees
      };
      await new SystemApi().createTrialAccount({
        createTrialAccountRequest: submitValues
      });
      this.$emit("submitted");
    });
  }
}
